import React from 'react'
import { useTranslations } from 'next-intl'
import { ACCOUNT_SIDE_PANEL_ITEMS } from '@/src/constants/accountSidePannel'
import { AccountsSidePanel } from './sidePanel'
import { useLocale } from 'next-intl'

interface AccountsSidePanelWrapperProps {
    activeIndex: number
}

const AccountsSidePanelWrapper: React.FC<AccountsSidePanelWrapperProps> = ({ activeIndex }) => {
    const t = useTranslations('header.userMenu')
    const locale = useLocale()
    const items = ACCOUNT_SIDE_PANEL_ITEMS.map(item => ({
        index: item.index,
        path: item.path,
        icon: item.icon,
        label: t(item.label)
    }))

    return <AccountsSidePanel items={items} activeIndex={activeIndex} locale={locale} />
}

export { AccountsSidePanelWrapper }
export type { AccountsSidePanelWrapperProps }
export default AccountsSidePanelWrapper

